import type { RouteLocationNormalizedGeneric } from 'vue-router';
import { resolvePostLoginRedirectTarget } from '~/utils/resolvePostLoginRedirectTarget';

export const usePostLoginUrl = (routeArg?: RouteLocationNormalizedGeneric) => {
    const route = routeArg?.fullPath ? routeArg : useRoute();
    const { lang } = useLanguage(routeArg);
    const countryLanguages = useCountryLanguages();
    const { data: config, refresh: refreshConfig } = useConfig(routeArg);

    const getPostLoginUrl = async () => {
        if (!config.value) {
            await refreshConfig();
        }

        return resolvePostLoginRedirectTarget(
            config.value?.content?.postLoginDefaultStory,
            unref(countryLanguages),
            lang.value,
            route.fullPath
        );
    };

    return {
        getPostLoginUrl
    };
};
